<template>
    <div class="app-container calendar-list-container">
        <div style="" v-if="type == true">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-size:18px;">管理员转让</span>
                </div>
                <span style="margin-left: 25px;color: #b4b7bd;">管理员转让，需要验证当前管理员的身份</span>
                <el-form ref="form" :model="form" label-width="80px" class="formwidth">
                    <el-form-item label="手机号" :span="12">
                        <el-input v-model="form.phone" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="验证码">
                        <el-input placeholder="请输入验证码" maxlength="6" v-model="form.code" :disabled="disabled" class="input-with-select">
                            <el-button slot="append" @click="getcode()" :disabled="disabled" type="info">{{codeName}}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="nextSubmit" size="mini">下一步</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div style="margin-top: 15px;" v-if="type == true">
            <el-card class="box-card cardtop">
                <div slot="header" class="clearfix">
                    <span style="font-size: 18px;">管理记录</span>
                </div>
                 <el-table :data="tableData" stripe style="width: 100%">
                    <el-table-column prop="userName" label="管理员姓名"></el-table-column>
                    <el-table-column prop="deptName" label="管理员所在部门"></el-table-column>
                    <el-table-column prop="phone" label="管理员手机号"></el-table-column>
                    <el-table-column prop="startTime"  label="管理时间">
                         <template slot-scope="scope">
                           {{dataday(scope.row.startTime)}}-{{scope.row.stopTime?dataday(scope.row.stopTime):'至今'}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
         <div style="" v-if="type == false">
            <el-card class="box-card hiddentop">
                <div slot="header" class="clearfix">
                    <span style="font-size:18px;">管理员转让</span>
                </div>
                <!-- <span style="margin-left: 25px;color: #b4b7bd;">查询并选择新的管理员</span> -->
                  <avue-crud :data="comworkerData" :option="tableoption"
                  :page="page" @current-change="currentChange" @size-change="sizeChange">
                    <template slot-scope="scope" slot="menuLeft"></template>
                     <template slot-scope="scope" slot="menu">
                        <el-button @click="changeadmin(scope.row,scope.index)" size="small">转让给TA</el-button>
                    </template>
                </avue-crud>
            </el-card>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <p>是否将管理员身份转让给{{username}}</p>
            <p>管理员转让后,需要重新登录系统</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeadminstate">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import {setcodephone,getAdminLog,Adminchengphone,changerole} from '@/api/admin/workerUser'
import {getWorkerInfo} from '@/api/admin/business'
 import {logout} from '@/api/admin/login'
import {personnelchange} from '@/const/asset/user'
import { dealElement } from '@/util/util'
import {datadayChinese} from '@/util/dateT'
import {objKeySort} from '@/util/ajaxsign'
import { set } from '@/api/admin/business';
export default {
  data() {
    return {
        codeName : '获取验证码',
        form : {
            phone :  undefined,
            code : undefined,
        },
        type : true,
        sign : '',//转化需要提交的数据
        ids : '',
        username : '',
        timer: undefined,
        disabled : false,
        tableData : [],
         // 企业员工数据
        comworkerData:[],
        comworkerId:'',
        search : {},
        form : {},
        listQuery: {
          current: 1,
          size: 10,
          total : 0,
        },
        page: {
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            total: 0,
            pageSize: 10
        },
         tableoption : personnelchange,
         dialogVisible : false,
    }
  },
  created(){
    this.getphone()
    this.getAdminLog()
  },
  methods: {
      //获取管理员验证码
      getphone(){
          console.log(JSON.parse(sessionStorage.getItem('userInfo')).phone)
          this.form.phone =  JSON.parse(sessionStorage.getItem('userInfo')).phone;
      },

      //获取验证码
      getcode(){
        if (!this.timer) {
            const TIME_COUNT = 10;
            this.count = TIME_COUNT;
            this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    // this.disabled = true;
                    this.codeName= this.count--+'秒后重新发送'
                } else {
                    this.codeName= '重新发送'
                    clearInterval(this.timer);
                    this.timer = undefined;
                     // this.disabled = false;
                }
            }, 1000)
        }
        setcodephone(objKeySort({phone:this.form.phone,type:4})).then(response => {
          if(response.data.code==200&&response.data.data){
            this.form.code = response.data.data;
          }
        })
      },

      //获取管理员记录
      getAdminLog(){
        getAdminLog(objKeySort()).then(response => {
            this.tableData = response.data.data;
        })
      },
      //设置时间
      dataday(data){
          return datadayChinese(data)
      },
      //下一步
      nextSubmit(){
        if(this.form.phone && this.form.code){
              Adminchengphone(objKeySort({phone:this.form.phone,code:this.form.code})).then(response => {
                if(response.data.code==200){
                  this.sign = response.data.data;
                  this.type = false;
                  this.getworker();
                }else{
                  this.$message('输入的验证码有误');
                }
              })

        }else{
          this.$message('管理员手机号或验证码为空');
        }
      },

      //获取员工信息
        getworker(){
          //获取企业员工列表
          let that=this
          var companyId=JSON.parse(sessionStorage.getItem('userInfo')).companyId;
          let _search = {
              pageNum: this.listQuery.current,
              pageSize: this.listQuery.size,
              companyId:companyId
          }
          getWorkerInfo(objKeySort(dealElement(_search))).then(response =>{
              that.comworkerData=response.data.data.rows;
              that.page.total = response.data.data.total;
          })
        },
         //条数
        sizeChange(val) {
          this.listQuery.size = val;
          this.page.pageSize = val;
          this.listQuery.current = 1;
          this.getworker()
        },
        //页码
        currentChange(val) {
          this.listQuery.current = val;
          this.page.currentPage = val;
          this.getworker()
        },
        //清空
        searchReset(){
          this.form={};
          this.listQuery.current = 1;
          this.listQuery.size = 10;
          this.getworker();
        },
        //搜索数据
        searchChange(params){
          let that=this
           that.getworker();
        },
        //转让管理员
        changeadmin(row,index){
            this.dialogVisible = true;
            this.ids = row.id;
            this.username = row.name;

        },
        //转让操作
        changeadminstate(){
            console.log(123456)
             changerole(objKeySort({secretKey:this.sign,userId:this.ids})).then(response =>{
                this.dialogVisible = false;
                if(response.data.code != 403){
                    this.$message({
                        type: 'info',
                        message: '转让成功'
                    });
                    logout(objKeySort()).then(response => {
                          sessionStorage.clear();
                        window.location.href = window.location.href.split('#')[0]+"index/login.html"
                    })
                }else{
                    this.type = true;
                     this.$message({
                        type: 'info',
                        message: '验证码失效'
                    });
                }

            })
        }
  }
}
</script>

<style lang="scss" scoped>
    .formwidth{
        width:38%;
    }
    .cardtop{
        margin-bottom: 20px;
    }
    .hiddentop ::v-deep.avue-crud__header{
      display: none;
    }
</style>
